import React, { useContext } from 'react'
import { css } from '@emotion/react'
import Tabs from 'gatsby-theme-marketplace-base/src/components/Product/Tabs'
import { ViewModeContext } from 'gatsby-theme-marketplace-base/src/context/viewMode'
import { VIEW_MODES } from 'gatsby-theme-marketplace-base/src/constants'
import { Divider } from 'gatsby-theme-marketplace-base/src/components/Divider'
import mediaQueries from '../../layout/media-queries'

const wrapperCss = css`
  @media (max-width: ${mediaQueries.BASE_SMALL_SIZE_NO_SIDEBAR - 1}px) {
    top: 95px;
  }

  @media (min-width: ${mediaQueries.BASE_SMALL_SIZE_NO_SIDEBAR}px) and (max-width: ${mediaQueries.BASE_SMALL_SIZE -
    1}px) {
    top: 52px;
  }
`

const dividerCss = css`
  margin-top: 16px;
  margin-bottom: 0px;
`

export default (props) => {
  const viewMode = useContext(ViewModeContext)
  const isEmbeddedView = viewMode === VIEW_MODES.EMBEDDED

  if (isEmbeddedView) {
    return (
      <span>
        <Divider css={dividerCss} />
      </span>
    )
  }

  return <Tabs css={wrapperCss} {...props} />
}
